import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: '#009D64',
    secondary: '#4EC1B6',
    error: '#F03335',
    light: '#8D8D8D',
    dark: {
      primary: '#1E1E1E',
      secondary: '#333333'
    }
  }
})
